import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { withStyles, MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Version from "version";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Slide from '@material-ui/core/Slide';
import Button from "components/CustomButtons/Button";
import ButtonX from '@material-ui/core/Button';
import ReactLoading from 'react-loading';
import Icon from "../components/Selfcare/Common/Icon";
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormHelperText from '@material-ui/core/FormHelperText';
import pink from '@material-ui/core/colors/pink';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import pricingPageStyle from "assets/jss/material-dashboard-pro-react/views/pricingPageStyle";

import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

// dotNetify
import dotnetify from 'dotnetify';

import auth from "../auth";
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

var reactPlugin = new ReactPlugin();

const MySwal = withReactContent(Swal);

const styles = theme => ({
    ...pricingPageStyle,
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    margin: {
        margin: theme.spacing(1),
    },
    cssLabel: {
        '&$cssFocused': {
            color: pink[500],
        },
    },
    cssFocused: {},
    cssUnderline: {
        '&:after': {
            borderBottomColor: pink[500],
        },
    },
});

const theme = createMuiTheme({
    palette: {
        primary: pink,
    },
    typography: { useNextVariants: true },
});


class Blocking extends Component {
    constructor(props) {
        super(props);
        this.vm = dotnetify.react.connect("Blocking", this, {
            headers: {
                Authorization: "Bearer " + auth.getAccessToken(),
                ClientVersion: Version.getVersion(),
                ServerToken: window.sessionStorage.ServerToken
            },
            exceptionHandler: _ => auth.signOut()
        });
        // Set up function to dispatch state to the back-end.
        this.dispatchState = state => this.vm.$dispatch(state);

        // we use this to make the card to appear after the page has been rendered
        this.state = {
            show: false,
            redirect: null,
            toUrl: null,
            Password: '',
            OrderSent: false,
            OrderError: '',
            buzy: false,
            ErrorField: '',
            ErrorText: '',
            Type: 'abonnement',
        };
    }
    componentDidMount() {
        setTimeout(
            function () {
                this.setState({ show: true });
            }.bind(this),
            700
        );
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (nextState.OrderConfirmation && !this.state.OrderConfirmation) {
            MySwal.fire({
                html: nextState.OrderConfirmation,
                icon: 'success',
                confirmButtonColor: '#e91e63',
            }).then((result) => {
                this.setState({ redirect: true, toUrl: '/overview' });
            });
        }
        if (nextState.OrderError && !this.state.OrderError) {
            MySwal.fire({
                title: this.props.t('selfcare:notification.blockingfailed'),
                html: nextState.OrderError,
                icon: 'error',
                confirmButtonColor: '#e91e63',
            });
            this.setState({ buzy: false });
        }
        if (nextState.ErrorField && !this.state.ErrorField) {
            this.setState({ buzy: false });
            this.setFocus(nextState.ErrorField);
        }
    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
        this.vm.$destroy();
    }
    setFocus = fieldName => {
        switch (fieldName) {
            case "Password":
                if (this.Password) {
                    setTimeout(() => {
                        this.Password.focus();
                    }, 10);
                }
                break;
        }
    }

    handleChange = name => event => {
        this.setState({ [name]: event.target.value, ErrorField: '' });
    }

    hideAlert = () => {
        this.setState({
            alert: null, buzy: false, OrderError: '', OrderSent: false
        });
    }

    navigateTo = url => {
        this.setState({ show: false });
        setTimeout(
            function () {
                this.setState({
                    toUrl: url,
                    redirect: true
                });
            }.bind(this),
            300
        );
    }
    render() {
        console.debug('OrderSimcard render');
        const classes = this.props;
        const { t } = this.props;
        return (
            <div style={{ height: '100vh' }}>
                {this.state.redirect ? <Redirect to={this.state.toUrl} /> : null}
                {this.state.IsAdministrating && <div style={{ backgroundColor: 'black', color: 'white', height: '50px', paddingLeft: '5px', textAlign: 'center', borderBottom: '1px grey solid' }}><span dangerouslySetInnerHTML={{ __html: t('selfcare:info.now-administrating-number', { 0: this.state.AdministratedMsisdn }) }} /><br /><a style={{ color: 'white' }} href='/overview' onClick={(e) => { sessionStorage.stopAdmin = this.state.LoggedInMsisdn; this.navigateTo('/overview'); e.preventDefault(); }}>{t('selfcare:button.back-to-logged-in-user')}</a></div>}
                    <div style={{ backgroundColor: '#e91e63', color: '#FFF', padding: '20px' }}>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={10} md={8} lg={6} xl={4} >
                                <Icon name="block-sim" size={48} color="#FFFFFF" />
                                <div style={{ fontSize: '20px', fontWeight: '700', maxWidth: '900px' }}>
                                    {t('selfcare:item.crisismustblock')}
                                </div>
                                <div style={{ fontSize: '14px', lineHeight: '16px' }}>
                                    <span dangerouslySetInnerHTML={{ __html: t('selfcare:item.howtoblock', {0: this.state.Type}) }} />
                                    {this.state.Type === 'abonnement' && <span dangerouslySetInnerHTML={{ __html: t('selfcare:item.blockedfixedprices') }} />}
                                </div>
                            </GridItem>
                        </GridContainer>
                    </div>
                    <form onSubmit={(e) => { e.preventDefault(); this.setState({ buzy: true, ErrorField: '' }); this.dispatchState({ PerformChange: { Password: this.state.Password, Reason: this.state.reason } }); }}>
                        <GridContainer justify="center">
                            <MuiThemeProvider theme={theme}>
                                <GridItem xs={12} sm={10} md={8} lg={6} xl={4} >
                                    {this.state.BlockingMessage && <div style={{ paddingTop: '20px', paddingLeft: '10px', paddingRight: '10px' }}>
                                        {this.state.BlockingMessage}
                                        <div style={{ paddingTop: '10px' }}>
                                            <Button id='back' color="rose" disabled={this.state.buzy} onClick={() => { this.navigateTo('/overview'); }}><Icon name="back" size={32} color="#FFFFFF" />{t('selfcare:button.back')}</Button>
                                        </div>
                                    </div>}
                                    {!this.state.BlockingMessage && !this.state.Blocked && <div style={{ paddingTop: '20px', paddingLeft: '10px', paddingRight: '10px' }}>
                                        <span style={{ fontWeight: '700' }}>{t('selfcare:info.block-sim-for')} </span><span style={{ color: '#e91e63', fontWeight: '700' }}>{this.state.FormattedMSISDN}</span>
                                        <div style={{ fontWeight: '700', paddingTop: '10px' }}>{t('selfcare:phrase.reason')}:</div>
                                        <FormControl component="fieldset" required error={this.state.ErrorField === 'Reason'}>
                                            <RadioGroup
                                                aria-label={t('selfcare:label.reason')}
                                                name="reason"
                                                value={this.state.reason}
                                                onChange={this.handleChange('reason')}
                                            >
                                                <FormControlLabel value="4" control={<Radio disabled={this.state.buzy} />} label={t('selfcare:label.lostphone')} />
                                                <FormControlLabel value="5" control={<Radio disabled={this.state.buzy} />} label={t('selfcare:label.stolenphone')} />
                                            </RadioGroup>
                                            <FormHelperText>{this.state.ErrorField === 'Reason' && this.state.ErrorText}</FormHelperText>
                                        </FormControl>
                                        <div style={{ maxWidth: '320px' }}>
                                            <TextField fullWidth error={this.state.ErrorField === 'Password'}
                                                disabled={this.state.buzy}
                                                label={t('selfcare:label.password')}
                                                value={this.state.Password}
                                                onChange={this.handleChange('Password')}
                                                id="Password"
                                                className={classes.textField}
                                                inputProps={{ maxLength: 30, type: 'password' }}
                                                helperText={this.state.ErrorField === 'Password' && this.state.ErrorText}
                                                inputRef={(el) => { this.Password = el }}
                                            />
                                        </div>
                                        <div style={{ fontSize: '12px', fontStyle: 'italic', paddingTop: '20px' }}>{t('selfcare:info.iploggedblock', { 0: this.state.Type})}</div>
                                        <GridContainer direction="row">
                                            <GridItem>
                                                <div style={{ paddingTop: '20px' }}>
                                                    <Button type="submit" size="sm" disabled={this.state.buzy} variant="contained" style={{ borderRadius: '19px', marginRight: '10px' }} color="rose">{t('selfcare:button.block')}</Button>
                                                    <ButtonX id='cancel' size="small" disabled={this.state.buzy} onClick={() => { this.navigateTo('/overview'); }}>{t('selfcare:button.cancel')}</ButtonX>
                                                </div>
                                            </GridItem>
                                        </GridContainer>

                                    </div>}
                                    {!this.state.BlockingMessage && this.state.Blocked && this.state.CanUnblock && <div style={{ paddingTop: '20px', paddingLeft: '10px', paddingRight: '10px' }}>
                                        <span style={{ fontWeight: '700' }}>{t('selfcare:info.open-sim-for')} </span><span style={{ color: '#e91e63', fontWeight: '700' }}>{this.state.FormattedMSISDN}</span>
                                        <div style={{ maxWidth: '320px' }}>
                                            <TextField fullWidth error={this.state.ErrorField === 'Password'}
                                                disabled={this.state.buzy}
                                                label={t('selfcare:label.password')}
                                                value={this.state.Password}
                                                onChange={this.handleChange('Password')}
                                                id="Password"
                                                className={classes.textField}
                                                inputProps={{ maxLength: 30, type: 'password' }}
                                                helperText={this.state.ErrorField === 'Password' && this.state.ErrorText}
                                                inputRef={(el) => { this.Password = el }}
                                            />
                                        </div>
                                        <div style={{ fontSize: '12px', fontStyle: 'italic', paddingTop: '20px' }}>{t('selfcare:info.iploggedunlock', { 0: this.state.Type })}</div>
                                        <GridContainer direction="row">
                                            <GridItem>
                                                <div style={{ paddingTop: '20px' }}>
                                                    <Button type="submit" size="sm" disabled={this.state.buzy} variant="contained" style={{ borderRadius: '19px', marginRight: '10px' }} color="rose">{t('selfcare:button.unlock')}</Button>
                                                    <ButtonX id='cancel' size="small" disabled={this.state.buzy} onClick={() => { this.navigateTo('/overview'); }}>{t('selfcare:button.cancel')}</ButtonX>
                                                </div>
                                            </GridItem>
                                        </GridContainer>

                                    </div>}
                                    {this.state.buzy && <GridItem>
                                        <ReactLoading type={"bubbles"} color={"#e91e63"} height={'50px'} width={'50px'} />
                                    </GridItem>}
                                </GridItem>
                            </MuiThemeProvider>
                        </GridContainer>
                    </form>
            </div>
        );
    }
}
Blocking.propTypes = {
};

export default compose(
    withStyles(styles),
    withTranslation(),
)(withAITracking(reactPlugin,Blocking));

